/**
 * We want to render an inner window around a timestamp within an outer window
 * Look at the unit tests for examples of what we're trying to achieve
 */
export const getMovingWindow = (
  timestamp: number,
  innerWindow: number,
  outerWindow: number,
) => {
  const [maxWindow, minWindow] = [innerWindow, outerWindow].sort(
    (a, b) => b - a,
  );
  const start = timestamp - minWindow / 2;
  const end = timestamp + minWindow / 2;

  let correction = 0;
  if (start < 0) {
    correction -= start;
  }

  if (end > maxWindow) {
    correction = maxWindow - end;
  }

  return {
    start: start + correction,
    end: end + correction,
  };
};
